/* TR PDP V4 QA: native Shopify/VOP remains the only authority for variant, cart, and checkout. */
(() => {
  const productSelector = 'product-info[id^="MainProduct-"]';
  const desktop = window.matchMedia('(min-width:990px)');
  const later = fn => { requestAnimationFrame(fn); setTimeout(fn, 100); setTimeout(fn, 350); };
  const initializers = new WeakSet();
  function init(owner) {
    const bar = owner.querySelector('.tr4-bar');
    if (!bar || initializers.has(bar)) return;
    const grid = owner.querySelector('.tr-pdp-v4');
    const vop = owner.querySelector('.tr-vop-container');
    if (!grid) return;
    initializers.add(bar);
    const variantData = owner.querySelector('#TR4VariantData-' + bar.dataset.tr4Section);
    let list;
    try { list = JSON.parse(variantData.textContent).variants; } catch (err) { return; }
    const variants = new Map(list.map(v => [String(v.id), v]));
    const desktopControls = bar.querySelector('[data-tr4-controls-desktop]');
    const mobileControls = bar.querySelector('[data-tr4-controls-mobile]');
    const drawer = bar.querySelector('[data-tr4-drawer]');
    const opener = bar.querySelector('[data-tr4-open]');
    const qtyInputs = Array.from(bar.querySelectorAll('[data-tr4-qty]'));
    const gallery = grid.querySelector('.product__media-wrapper > media-gallery');
    const productInfo = grid.querySelector('.product__info-wrapper > .product__info-container');
    const focusable = 'button:not([disabled]),select:not([disabled]),input:not([disabled]),a[href]';
    let savedFocus = null;
    let refreshing = false;

    const currentSubmit = () => owner.querySelector('.product-form__submit');
    const mainForm = () => {
      const btn = currentSubmit();
      return btn ? btn.closest('form') : null;
    };
    const currentVariant = () => {
      const form = mainForm();
      const input = form && form.querySelector('input[name="id"]');
      return input ? variants.get(String(input.value)) || null : null;
    };
    const nativeQuantity = () => owner.querySelector('quantity-input input[name="quantity"], .quantity__input[name="quantity"]');
    const active = el => el && (el.classList.contains('is-active') || el.getAttribute('aria-pressed') === 'true');
    const clean = value => (value || '').trim();
    const groups = () => {
      const out = [];
      if (!vop) return out;
      const vehicles = Array.from(vop.querySelectorAll('.tr-vop-vehicle-grid .tr-vop-vehicle-card, .tr-vop-vehicle-pills .tr-vop-vehicle-pill'));
      if (vehicles.length) {
        out.push({
          key:'vehicle',label:'Vehicle',buttons:vehicles,
          value:btn => btn.getAttribute('data-vehicle-canonical') || btn.getAttribute('data-vehicle-native-val') || btn.getAttribute('data-vehicle-display'),
          name:btn => clean(btn.getAttribute('data-vehicle-display')) || clean(btn.textContent),
        });
      }
      vop.querySelectorAll('.tr-vop-group--option').forEach(node => {
        const label = clean(node.getAttribute('data-option-name'));
        if (!label || /^(vehicle|fitment)$/i.test(label)) return;
        const buttons = Array.from(node.querySelectorAll('.tr-vop-btn[data-option-value]'));
        if (!buttons.length) return;
        out.push({
          key:'option-' + node.getAttribute('data-option-index'),label,buttons,
          value:btn => btn.getAttribute('data-option-value'),
          name:btn => clean(btn.getAttribute('data-option-value')),
        });
      });
      return out;
    };
    function buildControls(container) {
      if (!container) return;
      container.replaceChildren();
      groups().forEach(group => {
        const label = document.createElement('label');
        label.className = 'tr4-select';
        const caption = document.createElement('span');
        caption.textContent = group.label;
        const select = document.createElement('select');
        select.dataset.tr4Group = group.key;
        select.setAttribute('aria-label', group.label);
        group.buttons.forEach(btn => {
          const opt = document.createElement('option');
          opt.value = group.value(btn);
          opt.textContent = group.name(btn);
          if (btn.classList.contains('is-incompatible') || btn.disabled) opt.disabled = true;
          select.appendChild(opt);
        });
        select.addEventListener('change', () => {
          const existing = groups().find(g => g.key === group.key);
          if (!existing) return;
          const match = existing.buttons.find(btn => existing.value(btn) === select.value);
          if (match && !match.disabled && !match.classList.contains('is-incompatible')) {
            match.click(); // one source of truth: existing verified vehicle/variant resolver
            later(sync);
          } else {
            scheduleSync();
          }
        });
        label.append(caption, select);
        container.appendChild(label);
      });
    }
    function syncControls() {
      const stateGroups = groups();
      [desktopControls,mobileControls].forEach(slot => {
        if (!slot) return;
        if (slot.childElementCount !== stateGroups.length) buildControls(slot);
        slot.querySelectorAll('select[data-tr4-group]').forEach(select => {
          const group = stateGroups.find(g => g.key === select.dataset.tr4Group);
          if (!group) return;
          if (select.options.length !== group.buttons.length) {
            buildControls(slot);
            return;
          }
          group.buttons.forEach(btn => {
            const option = Array.from(select.options).find(o => o.value === group.value(btn));
            if (option) {
              option.disabled = !!(btn.disabled || btn.classList.contains('is-incompatible'));
              if (active(btn)) select.value = option.value;
            }
          });
        });
      });
      const v = stateGroups.find(g => g.key === 'vehicle');
      const selected = v && v.buttons.find(active);
      const vehicle = selected ? clean(selected.querySelector('.tr-vop-vehicle-card__name,.tr-vop-vehicle-pill__name')?.textContent) || v.name(selected) : '';
      const summary = bar.querySelector('[data-tr4-mobile-summary]');
      const curr = currentVariant();
      if (summary) summary.textContent = [vehicle, curr && curr.title !== 'Default Title' ? curr.title : ''].filter(Boolean).join(' · ') || 'Choose your vehicle and options';
    }
    function syncQuantities(newValue) {
      const native = nativeQuantity();
      let value = Math.max(1,Math.min(99,parseInt(newValue || native?.value || 1,10) || 1));
      if (native && Number(native.value) !== value) {
        native.value = String(value);
        native.dispatchEvent(new Event('input',{bubbles:true}));
        native.dispatchEvent(new Event('change',{bubbles:true}));
      }
      qtyInputs.forEach(input => {if(Number(input.value)!==value) input.value=String(value)});
    }
    function sync() {
      if(!bar.isConnected) return;
      const v = currentVariant();
      const nativeBtn = currentSubmit();
      const inStock = !!(v && v.available && nativeBtn && !nativeBtn.disabled);
      bar.querySelectorAll('[data-tr4-price]').forEach(el => {el.textContent=v ? v.price : 'Select options'});
      if(v?.image) bar.querySelectorAll('img[data-tr4-image]').forEach(img => {
        if (img.getAttribute('src') !== v.image) img.src = v.image;
      });
      bar.querySelectorAll('[data-tr4-add]').forEach(btn => {
        btn.disabled = !inStock;
        btn.textContent = v && !v.available ? 'Sold out' : 'Add to cart';
      });
      bar.querySelectorAll('[data-tr4-buy]').forEach(btn => {
        btn.disabled = !!(v && !v.available);
        btn.textContent = v && !v.available ? 'Sold out' : 'Buy it now';
      });
      syncControls();
      syncQuantities();
      updateGrid();
      updateBottomSpace();
    }
    function scheduleSync(){
      if(refreshing) return;
      refreshing=true;
      requestAnimationFrame(()=>{refreshing=false;sync()});
    }
    function updateBottomSpace() {
      document.body.classList.add('tr4-has-bar');
      const hasPreview = !!(document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame') || location.search.includes('preview_theme_id'));
      if (hasPreview && window.innerWidth < 990) {
        document.documentElement.setAttribute('data-tr4-preview', 'true');
        bar.style.bottom = '68px';
      } else {
        document.documentElement.removeAttribute('data-tr4-preview');
        bar.style.bottom = '';
      }
      document.documentElement.style.setProperty('--tr4-bar-height',Math.ceil(bar.getBoundingClientRect().height)+'px');
    }
    function updateGrid() {
      if (!gallery || !productInfo) return;
      if (!desktop.matches) {
        grid.dataset.tr4Stick = 'none';
        grid.style.removeProperty('--tr4-stick-top');
        return;
      }
      const left = gallery.offsetHeight;
      const right = productInfo.offsetHeight;
      if (!left || !right || Math.abs(left-right)<24) {
        grid.dataset.tr4Stick = 'none';return;
      }
      const shorter = Math.min(left,right);
      grid.dataset.tr4Stick = left < right ? 'media' : 'info';
      grid.style.setProperty('--tr4-stick-top',Math.round(Math.min(18,innerHeight-shorter-18))+'px');
    }
    function openDrawer() {
      if(!drawer.hidden) return;
      savedFocus=document.activeElement;
      drawer.hidden=false;
      opener.setAttribute('aria-expanded','true');
      document.body.classList.add('tr4-dialog-open');
      buildControls(mobileControls);
      syncControls();
      drawer.querySelector('.tr4-drawer__sheet')?.focus();
    }
    function closeDrawer() {
      if(drawer.hidden) return;
      drawer.hidden=true;
      opener.setAttribute('aria-expanded','false');
      document.body.classList.remove('tr4-dialog-open');
      if(savedFocus?.isConnected) savedFocus.focus();
    }
    function nativeBuy() {
      const v = currentVariant();
      if (!v || !v.available || currentSubmit()?.disabled) {openDrawer();return;}
      closeDrawer();
      // Call the original Shopify dynamic checkout button. Never invent checkout URLs.
      const native = owner.querySelector('.shopify-payment-button__button:not([disabled])');
      if (native && native.getClientRects().length) {
        native.click();
      } else {
        const payment = owner.querySelector('.shopify-payment-button') || currentSubmit();
        if (payment) {payment.scrollIntoView({behavior:'smooth',block:'center'});payment.querySelector('button')?.focus();}
      }
    }
    bar.addEventListener('click', event => {
      const button = event.target.closest('button');
      if(!button) return;
      if(button.matches('[data-tr4-open]')) {openDrawer();return;}
      if(button.matches('[data-tr4-close]')) {closeDrawer();return;}
      if(button.matches('[data-tr4-add]')) {
        const v=currentVariant();
        if (!v || !v.available) {openDrawer();return;}
        const native=currentSubmit();
        if(!native || native.disabled) return;
        closeDrawer();native.click();return;
      }
      if(button.matches('[data-tr4-buy]')) {nativeBuy();return;}
      if(button.hasAttribute('data-tr4-step')){
        const input=button.closest('.tr4-qty')?.querySelector('[data-tr4-qty]');
        syncQuantities((Number(input?.value)||1)+Number(button.dataset.tr4Step));
      }
    });
    bar.addEventListener('input',event=>{
      if(event.target.matches('[data-tr4-qty]'))syncQuantities(event.target.value);
    });
    drawer.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();closeDrawer();return;}
      if(event.key!=='Tab')return;
      const options=Array.from(drawer.querySelectorAll(focusable)).filter(e=>e.getClientRects().length);
      if(!options.length)return;
      if(event.shiftKey && document.activeElement===options[0]){event.preventDefault();options.at(-1).focus();}
      if(!event.shiftKey && document.activeElement===options.at(-1)){event.preventDefault();options[0].focus();}
    });
    if (vop) vop.addEventListener('click',()=>later(sync));
    owner.addEventListener('change',()=>later(sync));
    owner.addEventListener('input',scheduleSync);
    window.addEventListener('popstate',()=>later(sync));
    window.addEventListener('resize',scheduleSync,{passive:true});
    if('MutationObserver' in window) {
      const observer = new MutationObserver(scheduleSync);
      if (vop) observer.observe(vop,{attributes:true,attributeFilter:['class','aria-pressed'],subtree:true});
      const price=owner.querySelector('[id^="price-"]');
      if(price) observer.observe(price,{childList:true,characterData:true,subtree:true});
    }
    if('ResizeObserver' in window) {
      const ro=new ResizeObserver(()=>{updateGrid();updateBottomSpace()});
      ro.observe(bar);
      if(gallery)ro.observe(gallery);
      if(productInfo)ro.observe(productInfo);
    }
    buildControls(desktopControls);
    buildControls(mobileControls);
    sync();
    later(sync);
  }
  function scan(){document.querySelectorAll(productSelector).forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  window.addEventListener('load',scan,{once:true});
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('product-info:loaded',()=>requestAnimationFrame(scan));
  if('MutationObserver' in window){
    let pending=false;
    new MutationObserver(()=>{
      if(pending)return;
      pending=true;
      requestAnimationFrame(()=>{pending=false;scan()});
    }).observe(document.body||document.documentElement,{subtree:true,childList:true});
  }
})();
